import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import IntroSettings from "./IntroSettings";
import ShareSetting from "./ShareSetting";
import PasswordTypeSetting from "./PasswordTypeSetting";
import UserList from "./UserList";
import PasswordSetting from "./PasswordSetting";
import QRCodeScreen from "./QRCodeScreen";

export interface SettingProps {
  type?: String;
  setType?: (type: string) => void;
  step?: number;
  setStep?: (step: number) => void;
  passwordType?: string;
  setPasswordType?: (passwordType: string) => void;
}

const Settings = () => {
  const navigate = useNavigate();
  const [type, setType] = useState<string>(""); // share or password
  const [step, setStep] = useState<number>(1); // 1:인트로
  const [passwordType, setPasswordType] = useState<string>(""); // 1:결제, 2:로그인

  return (
    <Style>
      {step === 1 && (
        <>
          {type === "" ? (
            <IntroSettings setType={setType} setStep={setStep} />
          ) : type === "share" ? (
            <ShareSetting setStep={setStep} />
          ) : (
            <PasswordTypeSetting
              passwordType={passwordType}
              setPasswordType={setPasswordType}
              setStep={setStep}
            />
          )}
        </>
      )}
      {step === 2 && type === "share" && <UserList setStep={setStep} />}
      {(step === 2 && type === "password") ||
        (step === 4 && type === "share" && (
          <PasswordSetting passwordType={passwordType} />
        ))}
      {step === 3 && type === "share" && <QRCodeScreen setStep={setStep} />}
    </Style>
  );
};
export default Settings;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  h1.title {
    font-size: 44px;
    line-height: 104px;
    font-weight: 500;
    margin-bottom: 55px;
  }
  h2 {
    margin-top: 18px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
  }
  .logo {
    line-height: 100px;
    max-height: 100px;
    margin-bottom: 55px;
  }

  .listWrap {
    max-width: 100%;
    display: flex;
    padding: 0 10%;
    gap: 60px;
    overflow-x: auto;
  }
  .buttonBorder {
    min-width: 400px;
    max-width: 400px;
    min-height: 360px;
    max-height: 360px;
    padding: 3px;
    border-radius: 20px;
    background: linear-gradient(118.64deg, #dedede 2.57%, #262626 96.35%);
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background: linear-gradient(360deg, #111111 3.5%, #494949 100%);
      h1 {
        line-height: 80px;
        font-weight: 600;
      }
      h1.img {
        font-size: 56px;
        line-height: 120px;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .buttonBorder.active {
    background: linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
    button {
      background: linear-gradient(180deg, #648fe7 3.06%, #0d2a6c 97.5%);
    }
  }

  .buttonBorder.long {
    min-width: 400px;
    max-width: 860px;
    min-height: 100px;
    max-height: 100px;
    border-radius: 10px;
    margin-top: 60px;
    button {
      border-radius: 10px;
    }
  }

  @media (max-width: 1400px) {
    .listWrap {
      padding: 0 6%;
      gap: 50px;
    }
    .buttonBorder {
      button {
        img {
          width: 90px;
          height: 90px;
        }
      }
    }
  }
`;
